export default __webpack_public_path__ + "static/media/Speedy-Bearer.a49f3be8.png";